module.exports = __webpack_public_path__ + "img/diagram_011.b6b3d796.svg";